// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionItemsByEquipmentTableWrapper__JgPzk {
  padding: 15px !important;
}

.actionItemsByEquipmentTable__Smw_A {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
  box-shadow: var(--table-box-shadow);
}
.actionItemsByEquipmentTable__Smw_A th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 19px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
}
.actionItemsByEquipmentTable__Smw_A td {
  padding: 19px 25px;
  color: var(--tables-primary-row-text-main);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
  line-height: 16px;
}
@media (max-width: 1075px) {
  .actionItemsByEquipmentTable__Smw_A td {
    font-size: 12px;
  }
}

.bodyRow__U3aXS:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.sortIcon__Urn1f {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__Urn1f path {
  fill: var(--tables-title-icon);
}

.activeSort__ursmx path {
  fill: var(--tables-primary-row-icon);
}

.iconColumn__c9Avz {
  text-align: right;
  cursor: pointer;
}

.viewDetailsIcon__j_Apa {
  outline: none;
  vertical-align: baseline;
}

.skeletonText__btLrP {
  height: 16px;
  vertical-align: bottom;
}

.skeletonIcon__aKvl6 {
  width: 16px;
  height: 16px;
  vertical-align: bottom;
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/components/ActionItemsByEquipmentTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;AAzEF;AA2EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AAzEJ;AA4EE;EACE,kBAAA;EACA,0CAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA1EJ;AA4EI;EARF;IASI,eAAA;EAzEJ;AACF;;AA8EE;EACE,mDAAA;EACA,yDAAA;AA3EJ;;AA+EA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AA5EF;AA8EE;EACE,8BAAA;AA5EJ;;AAiFE;EACE,oCAAA;AA9EJ;;AAkFA;EACE,iBAAA;EACA,eAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,wBAAA;AA/EF;;AAkFA;EACE,YAAA;EACA,sBAAA;AA/EF;;AAkFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.actionItemsByEquipmentTableWrapper {\n  padding: 15px !important;\n}\n\n.actionItemsByEquipmentTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n  box-shadow: var(--table-box-shadow);\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 19px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n  }\n\n  td {\n    padding: 19px 25px;\n    color: var(--tables-primary-row-text-main);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n    line-height: 16px;\n\n    @media (max-width: 1075px) {\n      font-size: 12px;\n    }\n  }\n}\n\n.bodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.iconColumn {\n  text-align: right;\n  cursor: pointer;\n}\n\n.viewDetailsIcon {\n  outline: none;\n  vertical-align: baseline;\n}\n\n.skeletonText {\n  height: 16px;\n  vertical-align: bottom;\n}\n\n.skeletonIcon {\n  width: 16px;\n  height: 16px;\n  vertical-align: bottom;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionItemsByEquipmentTableWrapper": `actionItemsByEquipmentTableWrapper__JgPzk`,
	"actionItemsByEquipmentTable": `actionItemsByEquipmentTable__Smw_A`,
	"bodyRow": `bodyRow__U3aXS`,
	"sortIcon": `sortIcon__Urn1f`,
	"activeSort": `activeSort__ursmx`,
	"iconColumn": `iconColumn__c9Avz`,
	"viewDetailsIcon": `viewDetailsIcon__j_Apa`,
	"skeletonText": `skeletonText__btLrP`,
	"skeletonIcon": `skeletonIcon__aKvl6`
};
module.exports = ___CSS_LOADER_EXPORT___;
